import React from "react";
import "../../scss/index.scss";

export function Error404() {
  return <div></div>;
}
